import { createRef, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import chunk from "lodash/chunk";

import CheckboxInput from "../Checkbox.jsx";
import { classNames } from "../../helpers.js";

function selectKey(value) {
  if (Array.isArray(value)) {
    return value[1];
  }
  return value;
}
function useMinDistance(props) {
  if (props.options.range) {
    if (props.options.minDistance) {
      return (
        props.answer || [
          0,
          selectKey(props.options.possibleValues[props.options.minDistance]),
        ]
      );
    } else {
      return props.answer || [0, 0];
    }
  } else {
    return props.answer || 0;
  }
}

const CHUNK_LEN = 5;

export default function LikertScale(props) {
  const [value, setValue] = useState(useMinDistance(props));

  function handleChange(newValue) {
    if (value === newValue) {
      return;
    }
    setValue(newValue);
  }

  useEffect(() => {
    // Setting it initially just to make hitting ok work
    props.onSelect(value);
  }, [value]);

  const [from, to] = props.options.scale || [1, 10];
  let opts = [];
  for (let i = from; i <= to; i++) {
    opts.push(i);
  }

  return (
    <div class="likert-scale" role="radiogroup">
      {chunk(opts, CHUNK_LEN).map((values) => (
        <div class="likert-scale__chunk mb-12">
          {values.map((v) => (
            <span
              role="radio"
              id="question-likert"
              name="answer"
              class={classNames(
                "likert-scale__item",
                value == v && "likert-scale__item--selected"
              )}
              onClick={() => handleChange(v)}
            >
              {v}
            </span>
          ))}
        </div>
      ))}
    </div>
  );
}
